// import React from "react";
// import Select from "react-select";

// export default function FilterBar({
//   filters,
//   masters,
//   setFilter,
//   onApply,
//   onDownload,
//   loading,
//   downloading,
//   data,
//   isConsolidated,
// }) {
//   const update = (k, v) => setFilter((prev) => ({ ...prev, [k]: v }));
//   const outletOptions = [
//     { value: "", label: "All" },
//     ...masters.outlets.map((o) => ({ value: o, label: o })),
//   ];

//   return (
//     <div className="card p-3 mb-4 shadow-sm">
//       <div className="row g-3">
//         <div className="col-md-3">
//           <label className="form-label">Report Type</label>
//           <select
//             className="form-select"
//             value={filters.type}
//             onChange={(e) => update("type", e.target.value)}
//           >
//             <option value="daily">Daily</option>
//             <option value="range">Range / Weekly</option>
//             <option value="monthly">Monthly</option>
//           </select>
//         </div>

//         {filters.type === "daily" && (
//           <div className="col-md-3">
//             <label className="form-label">Date</label>
//             <input
//               type="date"
//               className="form-control"
//               value={filters.date}
//               onChange={(e) => update("date", e.target.value)}
//             />
//           </div>
//         )}

//         {filters.type === "range" && (
//           <>
//             <div className="col-md-3">
//               <label className="form-label">From</label>
//               <input
//                 type="date"
//                 className="form-control"
//                 value={filters.from_date}
//                 onChange={(e) => update("from_date", e.target.value)}
//               />
//             </div>
//             <div className="col-md-3">
//               <label className="form-label">To</label>
//               <input
//                 type="date"
//                 className="form-control"
//                 value={filters.to_date}
//                 onChange={(e) => update("to_date", e.target.value)}
//               />
//             </div>
//           </>
//         )}

//         {filters.type === "monthly" && (
//           <div className="col-md-3">
//             <label className="form-label">Month</label>
//             <input
//               type="month"
//               className="form-control"
//               value={filters.month}
//               onChange={(e) => update("month", e.target.value)}
//             />
//           </div>
//         )}

//         {/* <div className="col-md-3">
//           <label className="form-label">Outlet</label>
//           <select
//             className="form-select"
//             value={filters.outlet}
//             onChange={(e) => update("outlet", e.target.value)}
//           >
//             <option value="">All</option>
//             {masters.outlets.map((o, i) => (
//               <option key={i} value={o}>
//                 {o}
//               </option>
//             ))}
//           </select>
//         </div> */}

//         <div className="col-md-3">
//           <label className="form-label">Outlet</label>
//           <Select
//             value={outletOptions.find((opt) => opt.value === filters.outlet)}
//             onChange={(selected) =>
//               update("outlet", selected ? selected.value : "")
//             }
//             options={outletOptions}
//             placeholder="Select or search outlet..."
//             isClearable
//             isSearchable
//             styles={{
//               control: (base) => ({
//                 ...base,
//                 borderRadius: "8px",
//                 borderColor: "#dee2e6",
//                 minHeight: "38px",
//               }),
//               option: (base, state) => ({
//                 ...base,
//                 color: "#00a0d0",
//                 backgroundColor: state.isFocused ? "#e8f8ff" : "white",
//               }),
//             }}
//           />
//         </div>

//         <div className="col-md-3">
//           <label className="form-label">Department</label>
//           <select
//             className="form-select"
//             value={filters.department}
//             onChange={(e) => update("department", e.target.value)}
//           >
//             <option value="">All</option>
//             {masters.departments.map((d, i) => (
//               <option key={i} value={d}>
//                 {d}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="col-md-3">
//           <label className="form-label">Employee</label>
//           <select
//             className="form-select"
//             value={filters.employee_id}
//             onChange={(e) => update("employee_id", e.target.value)}
//           >
//             <option value="">All</option>
//             {masters.employees.map((emp) => (
//               <option key={emp.id} value={emp.id}>
//                 {emp.employee_code} - {emp.first_name}
//               </option>
//             ))}
//           </select>
//         </div>

//         <div className="col-md-3 d-flex align-items-end">
//           <button
//             className="btn duty-roster-upload-btn gap-1 w-100"
//             onClick={onApply}
//           >
//             {loading ? (
//               <span className="spinner-border spinner-border-sm"></span>
//             ) : (
//               "Generate"
//             )}
//           </button>
//         </div>

//         <div className="col-md-3 d-flex align-items-end">
//           <button
//             className="btn btn-success w-100"
//             onClick={onDownload}
//             disabled={downloading || data.length === 0}
//           >
//             {downloading ? (
//               <span className="spinner-border spinner-border-sm"></span>
//             ) : (
//               "⬇ Download"
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect } from "react";
import Select from "react-select";

export default function FilterBar({
  filters,
  masters,
  setFilter,
  onApply,
  onDownload,
  loading,
  downloading,
  data,
  isConsolidated,
}) {
  const update = (k, v) => setFilter((prev) => ({ ...prev, [k]: v }));

  useEffect(() => {
    const today = new Date();
    const todayStr = today.toISOString().split("T")[0];
    const currentMonth = today.toISOString().slice(0, 7);

    if (filters.type === "daily" && !filters.date) {
      update("date", todayStr);
    }

    if (filters.type === "range") {
      if (!filters.from_date) update("from_date", todayStr);
      if (!filters.to_date) update("to_date", todayStr);
    }

    if (filters.type === "monthly" && !filters.month) {
      update("month", currentMonth);
    }
  }, [filters.type]);

  const outletOptions = [
    { value: "", label: "All" },
    ...masters.outlets.map((o) => ({ value: o, label: o })),
  ];

  const departmentOptions = [
    { value: "", label: "All" },
    ...masters.departments.map((d) => ({ value: d, label: d })),
  ];

  const employeeOptions = [
    { value: "", label: "All" },
    ...masters.employees.map((emp) => ({
      value: emp.id,
      label: `${emp.employee_code} - ${emp.first_name}`,
    })),
  ];

  const customSelectStyle = {
    control: (base) => ({
      ...base,
      borderRadius: "8px",
      borderColor: "#dee2e6",
      minHeight: "38px",
    }),
    option: (base, state) => ({
      ...base,
      color: "#00a0d0",
      backgroundColor: state.isFocused ? "#e8f8ff" : "white",
    }),
  };

  return (
    <div className="card p-3 mb-4 shadow-sm">
      <div className="row g-3">
        {/* Report Type */}
        <div className="col-md-3">
          <label className="form-label">Report Type</label>
          <select
            className="form-select"
            value={filters.type}
            onChange={(e) => update("type", e.target.value)}
          >
            <option value="daily">Daily</option>
            <option value="range">Range / Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
        </div>

        {/* Date Inputs */}
        {filters.type === "daily" && (
          <div className="col-md-3">
            <label className="form-label">Date</label>
            <input
              type="date"
              className="form-control"
              value={filters.date}
              onChange={(e) => update("date", e.target.value)}
            />
          </div>
        )}

        {filters.type === "range" && (
          <>
            <div className="col-md-3">
              <label className="form-label">From</label>
              <input
                type="date"
                className="form-control"
                value={filters.from_date}
                onChange={(e) => update("from_date", e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label className="form-label">To</label>
              <input
                type="date"
                className="form-control"
                value={filters.to_date}
                onChange={(e) => update("to_date", e.target.value)}
              />
            </div>
          </>
        )}

        {filters.type === "monthly" && (
          <div className="col-md-3">
            <label className="form-label">Month</label>
            <input
              type="month"
              className="form-control"
              value={filters.month}
              onChange={(e) => update("month", e.target.value)}
            />
          </div>
        )}

        {/* Outlet */}
        <div className="col-md-3">
          <label className="form-label">Outlet</label>
          <Select
            value={outletOptions.find((opt) => opt.value === filters.outlet)}
            onChange={(selected) =>
              update("outlet", selected ? selected.value : "")
            }
            options={outletOptions}
            placeholder="Select or search outlet..."
            isClearable
            isSearchable
            styles={customSelectStyle}
          />
        </div>

        {/* Department */}
        <div className="col-md-3">
          <label className="form-label">Department</label>
          <Select
            value={departmentOptions.find(
              (opt) => opt.value === filters.department
            )}
            onChange={(selected) =>
              update("department", selected ? selected.value : "")
            }
            options={departmentOptions}
            placeholder="Select or search department..."
            isClearable
            isSearchable
            styles={customSelectStyle}
          />
        </div>

        {/* Employee */}
        <div className="col-md-3">
          <label className="form-label">Employee</label>
          <Select
            value={employeeOptions.find(
              (opt) => opt.value === filters.employee_id
            )}
            onChange={(selected) =>
              update("employee_id", selected ? selected.value : "")
            }
            options={employeeOptions}
            placeholder="Select or search employee..."
            isClearable
            isSearchable
            styles={customSelectStyle}
          />
        </div>

        {/* Generate Button */}
        <div className="col-md-3 d-flex align-items-end">
          <button
            className="btn duty-roster-upload-btn gap-1 w-100"
            onClick={onApply}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm"></span>
            ) : (
              "Generate"
            )}
          </button>
        </div>

        {/* Download Button */}
        <div className="col-md-3 d-flex align-items-end">
          <button
            className="btn btn-success w-100"
            onClick={onDownload}
            disabled={downloading || data.length === 0}
          >
            {downloading ? (
              <span className="spinner-border spinner-border-sm"></span>
            ) : (
              "⬇ Download"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
